import { Expose, Type } from "class-transformer";
import { SignaturePlacementFieldTypeEnum } from "@/core/features/employee-document-categories/signature-placement-field-type.enum";

export class SignaturePlacementDto {
  @Expose()
  id?: string;

  @Expose()
  @Type(() => Number)
  pageNumber: number;

  @Expose()
  @Type(() => Number)
  xRatio: number;

  @Expose()
  @Type(() => Number)
  yRatio: number;

  @Expose()
  @Type(() => Number)
  widthRatio: number;

  @Expose()
  @Type(() => Number)
  heightRatio: number;

  @Expose()
  @Type(() => Number)
  sortOrder?: number;

  @Expose()
  fieldType: SignaturePlacementFieldTypeEnum;
}
